export default function InvitationsExpired() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center">
        <h1 className="text-3xl font-bold text-indigo-600 mb-6">Gosellgo</h1>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <p className="text-xl font-bold text-gray-900">Inbjudan har gått ut</p>
          <p className="text-gray-500 mt-2">
            Den här inbjudningslänken har gått ut. Be om en ny.
          </p>
          <a
            href="/sign_in"
            className="mt-6 inline-block text-indigo-600 hover:underline text-sm"
          >
            Gå till inloggning
          </a>
        </div>
      </div>
    </div>
  )
}
